import { RadioButtonChangeParams } from 'primereact/radiobutton'
import { useTranslation } from 'react-i18next'

import { GymListRadioWrapper, GymListTypeWrapper, StyledRadioButton, StyledRadioLabel } from './styled'

interface ComponentProps {
  selectedType: string
  handleChange: (e: RadioButtonChangeParams) => void
}

export default function GymListTypeRadio({ selectedType, handleChange }: ComponentProps) {
  const { t } = useTranslation()
  const listTypes = [
    { key: 'personal', name: t('input-texts.personal-work') },
    { key: 'group', name: t('input-texts.group-lesson') },
    { key: 'trainer', name: t('input-texts.pt-work') },
  ]

  return (
    <GymListTypeWrapper>
      {listTypes.map((type) => {
        const hasChecked = selectedType === type.key

        return (
          <GymListRadioWrapper key={type.key}>
            <StyledRadioButton
              inputId={type.key}
              name="listType"
              value={type.key}
              onChange={handleChange}
              checked={hasChecked}
            />
            <StyledRadioLabel isSelected={selectedType === type.key} htmlFor={type.key}>
              {type.name}
            </StyledRadioLabel>
          </GymListRadioWrapper>
        )
      })}
    </GymListTypeWrapper>
  )
}
